import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Network } from '@capacitor/network';
import { Dialog } from '@capacitor/dialog';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

Network.addListener('networkStatusChange', status => {
  if (!status.connected) {
    Dialog.alert({
      title: 'No Internet',
      message: 'Check internet connection',
    });
  }
});